import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "src/dm/utils/axios";
import { APIS } from "src/dm/utils/constants";
import { DealItem, DealItemWriteRequest } from "src/dm/interfaces/DealItem";

interface Envelope {
  items: DealItem[];
  total: number;
}

const itemsUrl = (dealId: number) => `${APIS.Deals}/${dealId}/items`;

export const useDealItems = (dealId: number | undefined) =>
  useQuery({
    queryKey: ["deal-items", dealId],
    enabled: dealId !== undefined && dealId > 0,
    queryFn: async (): Promise<DealItem[]> => {
      const response = await apiClient.get<Envelope>(itemsUrl(dealId as number));
      return response.data.items;
    },
  });

export const useAddDealItem = (dealId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: DealItemWriteRequest): Promise<DealItem> => {
      const response = await apiClient.post<DealItem>(itemsUrl(dealId), body);
      return response.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["deal-items", dealId] });
    },
  });
};

export const useDeleteDealItem = (dealId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (dealItemId: number): Promise<void> => {
      await apiClient.delete(`${itemsUrl(dealId)}/${dealItemId}`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["deal-items", dealId] });
    },
  });
};
